import { AxiosTencerAdminApiClient } from 'app/shared/infrastructure/api/AxiosTencerAdminApiClient';
import { MaintenanceRepository } from 'app/modules/settings/domain/repository/MaintenanceRepository';
import { MaintenancePageMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/MaintenancePageMapper';
import { MaintenancePage } from 'app/modules/settings/domain/entity/MaintenancePage';
import { MaintenancePageId } from 'app/modules/settings/domain/valueObject/MaintenancePageId';
import { MaintenancePageOrigin } from 'app/modules/settings/domain/valueObject/MaintenancePageOrigin';
import { TranslationArrayMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/TranslationArrayMapper';
import { TranslationArray } from 'app/modules/settings/domain/entity/TranslationArray';
import { SettingNameResponse } from 'app/modules/settings/infrastructure/dto/response/SettingResponse';

export class ApiMaintenanceRepository implements MaintenanceRepository {

    constructor(private _apiClient: AxiosTencerAdminApiClient) {}

    public async findByOrigin(origin: MaintenancePageOrigin): Promise<MaintenancePage> {
        const [data, settingsData] = await Promise.all([
            this._apiClient.fetchGetMaintenanceByOrigin(origin.value),
            this._apiClient.fetchGetInMaintenanceSettings(),
        ]);

        const maintenanceStates = this.buildMaintenanceStatesMap(settingsData.data);
        const inMaintenance = maintenanceStates.get(origin.value) || false;

        return MaintenancePageMapper.toDomain(data.data, inMaintenance);
    }

    public async update(id: MaintenancePageId, translations: TranslationArray): Promise<string> {
        const result = await this._apiClient.fetchPutMaintenanceItem({
            maintenanceId: id.value,
            payload: {
                translations: TranslationArrayMapper.fromDomain(translations),
            },
        });

        return result.data;
    }

    public async toggleMaintenance(origin: MaintenancePageOrigin, inMaintenance: boolean): Promise<void> {
        await this._apiClient.fetchPatchInMaintenance({
            origin: origin.value,
            inMaintenance,
        });
    }

    // eslint-disable-next-line max-len
    private buildMaintenanceStatesMap(settings: Array<{ name: string; origin: number; value: number }>): Map<number, boolean> {
        const maintenanceStates = new Map<number, boolean>();
        settings.forEach((setting) => {
            if (setting.name === SettingNameResponse.IN_MAINTENANCE) {
                // value is 0 (false) or 1 (true)
                maintenanceStates.set(setting.origin, setting.value === 1);
            }
        });
        return maintenanceStates;
    }

}
